import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import {
  PermissionConfigEntry,
  PermissionId,
  isPermissionVisibleInUi,
  workspacesConfig,
} from 'utils/powerLevelsConfig';

/**
 * Returns the V2 permission config entries the given role has enabled —
 * an entry is enabled when the role's PL in that entry's scope is `>=` the
 * entry's required PL. Scope-aware: each entry is evaluated against its own
 * scope's PL independently. See spec/tech.md §3.2 and §3.7.
 *
 * Read-only render helper. Consumers: `UneditableRole`, future role-detail
 * read-only views. For pure counts, use `getEnabledPermissionCount`.
 */
const getEnabledPermissionsForRole = (
  role: WorkspaceRoleV2,
  config: Record<PermissionId, PermissionConfigEntry> = workspacesConfig
): PermissionConfigEntry[] =>
  Object.values(config).filter(
    (entry) => isPermissionVisibleInUi(entry) && role.powerLevels[entry.scope] >= entry.powerLevel
  );

export default getEnabledPermissionsForRole;
